<template>
	<div class="auth password-recover">
		<h1>{{ $t('base.auth.recover_password') }}</h1>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<div v-if="success">
				<div class="alert alert-success">{{ success }}</div>
				<router-link class="btn btn-primary" :to="{ name: 'AuthLogin' }">{{ $t('base.auth.login') }}</router-link>
			</div>
			<error-box v-if="error" :error="error"/>
			<div v-if="!success">
				<input-password v-model="model.password" name="password" placeholder="Password" rules="required|min:8"/>
				<input-password v-model="model.confirm_password" name="confirm_password" placeholder="Confirm password" :rules="'required|confirmed:'+model.password"/>
				<button class="btn btn-primary" type="submit">{{ $t('base.auth.confirm') }}</button>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	props: [
		'hash'
	],
	data () {
		return {
			model: {
				password: '',
				confirm_password: '',
			},
			success: '',
			error: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			this.success = ''
			this.error = ''
			this.$api.auth.passwordRecover(this, { hash: this.hash, password: this.model.password }).then(response => {
				this.$log.info('user password recover', 'auth.passwordRecover OK', response)()
				this.success = response.body.message
			}).catch((errors) => {
				this.$log.error('user password recover', 'auth.passwordRecover ERROR', errors)()
				this.error = errors
			})
		}
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.recover_password'))
	}
}
</script>



// WEBPACK FOOTER //
// src/components/auth/AuthPasswordRecover.vue